import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./ADSInput.module.scss";
import { useMemo } from "react";
import ADSInputCopy from "./ADSInputCopy";

const CustomInput = styled(TextField)(({ disabled, theme }) => ({
  backgroundColor: disabled ? "rgba(0, 0, 0, 0.12)" : "#FFF1F2",
  margin: 0,
  borderRadius: "15px 15px 0 0",
  padding: "28px 28px 0 28px",
  boxSizing: "border-box",

  "& .Mui-disabled": {
    color: theme.palette.text.disabled,
    WebkitTextFillColor: "#1D1B201A",
    backgroundColor: "#DEDEDE",
  },

  ".MuiInputBase-root": {
    borderRadius: "15px",
    fontSize: "17px",
    fontWeight: "400",
    fontFamily: "Inter",

    "&::before, &::after": {
      display: "none",
    },

    ".MuiInputBase-input": {
      color: theme.palette.text.primary,

      "&::-webkit-scrollbar": {
        width: "6px", // Thin scrollbar width
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#FB4764", // Scrollbar color
        borderRadius: "10px", // Rounded edges for scrollbar thumb
        "&::hover": { cursor: "pointer" },
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent", // Track background
      },
    },
  },
}));

const ADSInput = ({
  placeholder,
  value = "",
  onChange,
  row = 8,
  disabled,
  maxKeywords = 100,
}) => {
  const wordCount = useMemo(
    () => (value ? value.split(" ").length : 0),
    [value]
  );

  return (
    <section>
      <CustomInput
        className="check"
        fullWidth
        multiline
        autoComplete="off"
        variant="standard"
        rows={row}
        margin="normal"
        value={value}
        onChange={(e) => {
          const keywords = e.target.value?.split(" ") || [];
          onChange(keywords.slice(0, maxKeywords).join(" "));
        }}
        placeholder={placeholder}
        disabled={disabled}
      />
      <div
        className={`${styles.extraContent} ${disabled ? styles.disabled : ""}`}
      >
        <ADSInputCopy text={value} disabled={disabled || !value} />

        <span
          style={{ color: disabled ? "#1D1B201A" : "#646666CC", fontSize: 12 }}
        >
          {wordCount} out of {maxKeywords} keywords
        </span>
      </div>
    </section>
  );
};

export default ADSInput;
